export const displayNotification = data => ({
    type: "DISPLAY_NOTIFICATION",
    data
  });

  export const maintainDisplayNotification = data => ({
    type: "BIKE_DISPLAY_NOTIFICATION",
    data
  });
